import React from "react";
import { Fade } from "react-awesome-reveal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import emailjs from "emailjs-com";

import { Form } from "elements/Form";
import Button from "elements/Button";

export const DiscussForm = (actions) => {
  const { data, resetForm, onChange } = actions;

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, company, email, phone, projectIdea } = data;

    if (name !== "" && company !== "" && email !== "" && phone !== "" && projectIdea !== "") {
      const templateParams = { name, company, email, phone, projectIdea };

      emailjs
        .send(
          "service_04bbdvm",
          "template_fx12k5o",
          templateParams,
          "2ChxYnhVr3wbWA87f",
        )
        .then(
          () => {
            toast.success("Form submitted successfully! We'll get back to you soon.");
            resetForm();
          },
          () => {
            toast.error("There was an error sending your form. Please try again.");
          },
        );
    } else {
      toast.error("Please fill out the blank form.");
    }
  };

  return (
    <section className="container mx-auto mt-10 flex flex-col justify-center px-4">
      <Fade direction="up" triggerOnce>
        <p className="mb-2 text-center text-sm font-semibold uppercase tracking-widest text-gold-700">
          Get In Touch
        </p>
        <h1 className="text-center font-display text-4xl text-maroon-900 sm:text-5xl">
          Let&apos;s Discuss
        </h1>
        <p className="mx-auto mb-10 mt-3 max-w-xl text-center text-lg font-light text-slate-500">
          Reach out for product inquiries, custom orders, or partnership opportunities.
        </p>
      </Fade>

      <Fade direction="up" triggerOnce>
        <form
          onSubmit={handleSubmit}
          className="mx-auto flex w-full max-w-2xl flex-col rounded-2xl border border-slate-100 bg-white p-6 shadow-lg sm:p-10"
        >
          <div className="flex flex-col sm:flex-row sm:justify-between">
            <Form
              id="name"
              name="name"
              type="text"
              label="Your name"
              value={data.name}
              placeholder="e.g. Rohan Sharma"
              onChange={onChange}
            />
            <Form
              id="company"
              name="company"
              type="text"
              label="Your company"
              value={data.company}
              placeholder="e.g. Sharma Restaurants"
              onChange={onChange}
            />
          </div>

          <div className="flex flex-col sm:flex-row sm:justify-between">
            <Form
              id="email"
              name="email"
              type="email"
              label="Your email address"
              value={data.email}
              placeholder="you@company.com"
              onChange={onChange}
            />
            <Form
              id="phone"
              name="phone"
              type="number"
              label="Your contact number"
              value={data.phone}
              placeholder="10-digit phone number"
              onChange={onChange}
            />
          </div>

          <Form
            id="projectIdea"
            name="projectIdea"
            type="textarea"
            label="Your message"
            value={data.projectIdea}
            placeholder="Tell us what you're looking for…"
            className="w-full"
            onChange={onChange}
          />

          <Button
            className="mx-auto mt-3 rounded-full bg-maroon-700 px-12 py-3 text-lg font-semibold text-white transition-colors hover:bg-maroon-800 focus:outline-none"
            type="submit"
          >
            Submit
          </Button>
        </form>
      </Fade>

      <ToastContainer />
    </section>
  );
};
